import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaQrcode } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { disponivel, escanear } from '../platform/scanner';
import { destinoDaLeitura } from '../platform/leitura';

/**
 * Leitor unico da barra de cima: uma camera para os dois mundos.
 *
 * A pessoa nao decide antes o que vai ler. Ela aponta para o pote (QR da
 * etiqueta) ou para a embalagem (codigo de barras), e o destino sai do FORMATO
 * que a camera reportou — ver `platform/leitura.js`, onde mora o porque de nao
 * olhar so para o texto.
 *
 * Nao renderiza na web: `disponivel()` e falso fora do app, e um botao de
 * camera que nao abre camera e pior que botao nenhum.
 */
export default function BotaoLeitor() {
  const [lendo, setLendo] = useState(false);
  const navigate = useNavigate();

  if (!disponivel()) return null;

  const abrir = async () => {
    if (lendo) return;
    setLendo(true);
    try {
      const r = await escanear({ tipo: 'ambos' });
      if (!r.ok) {
        if (r.motivo === 'sem-permissao') {
          toast.warn('Libere o acesso à câmera nas configurações do aparelho.');
        } else if (r.motivo === 'erro') {
          toast.error('Não consegui ler. Tente de novo com mais luz.');
        }
        // 'cancelado' e silencioso: fechou de proposito.
        return;
      }

      const destino = destinoDaLeitura(r.formato, r.valor);
      if (destino.tipo === 'desconhecido') {
        // QR que nao e do Metria: dizer o que foi lido e melhor que "erro",
        // porque a pessoa consegue conferir se apontou para o papel certo.
        toast.info('Este QR não é de uma etiqueta do Metria.');
        return;
      }
      navigate(destino.caminho);
    } finally {
      setLendo(false);
    }
  };

  return (
    <button
      type="button"
      onClick={abrir}
      disabled={lendo}
      title="Ler etiqueta ou código de barras"
      aria-label="Ler etiqueta ou código de barras"
      className="mobile-topbar-leitor"
    >
      <FaQrcode size={18} />
    </button>
  );
}
